import { adminUtilsSerializer } from '@/providers/serializers/admin-utils/admin-utils';
import { http } from '../http';

export class AdminUtilsAPI {

    private static INSTANCE = new AdminUtilsAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private nameSpace: string = 'api/v1/admin-utils';

    public fetchOAthClientSecret(payload: any) {
        const endpoint = `${this.nameSpace}/oauth-clients`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, payload).then((responce) => {
            return adminUtilsSerializer.normalizeOAthClientSecret(responce.data);
        });
    }

    public fetchOAuthConfig(parmas: any) {
        const endpoint = `${this.nameSpace}/oauth-clients`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, parmas).then((responce) => {
            return adminUtilsSerializer.normalizeGetOAthClientSecret(responce.data);
        });
    }

    public fetchTenantList(parmas: any) {
        const endpoint = `${this.nameSpace}/tenant`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, parmas).then((res) => {
            return adminUtilsSerializer.tenantListSerializer(res.data);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public fetchTenantStats(parmas: any) {
        const endpoint = `${this.nameSpace}/tenant/stats`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, parmas).then((res) => {
            return adminUtilsSerializer.tenantListSerializer(res.data);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public resetPassword(params: any) {
        const endpoint = `${this.nameSpace}/reset-password`;
        const headers = http.getTokenHeaders();
        return http.put(endpoint, headers, params).then((responce) => {
            return responce.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public saveSettingKey(params: any) {
        const endpoint = `${this.nameSpace}/tenant-setting-config`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public updateSettingKey(params: any) {
        const endpoint = `${this.nameSpace}/tenant-setting-config/${params.setting_key}`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public deleteSettingKey(params: any) {
        const endpoint = `${this.nameSpace}/tenant-setting-config/${params.setting_key}`;
        const header = http.getTokenHeaders();
        return http.delete(endpoint, header).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public archiveMultipleClasses(params: any) {
        const endpoint = `${this.nameSpace}/classes/archive`;
        const headers = http.getTokenHeaders();
        return http.put(endpoint, headers, params).then((responce) => {
            return responce.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public addUser(params: any) {
        const endpoint = `${this.nameSpace}/users`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((responce) => {
            return responce.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public updateUserRole(params: any) {
        const endpoint = `${this.nameSpace}/users`;
        const headers = http.getTokenHeaders();
        return http.put(endpoint, headers, params).then((responce) => {
            return responce.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public addSchool(params: any) {
        const endpoint = `${this.nameSpace}/users/school`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((responce) => {
            return responce.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }


    public getClassDetails(param: any) {
        const endpoint =  `${this.nameSpace}/classes`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, param).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public updateClassGroup(groupId: any, classID: any) {
        const endpoint =  `${this.nameSpace}/class/${classID}?group_id=${groupId}`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public loadManualSync() {
        const endpoint = `${this.nameSpace}/oneroster/manual-sync`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers).then((responce) => {
            return responce.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }
    public updateGroup(params: any, groupId: any) {
        const endpoint = `${this.nameSpace}/groups/${groupId}`;
        const headers = http.getTokenHeaders();
        return http.put(endpoint, headers, params).then((responce) => {
            return responce.data;
        }).catch((error: any) => {
            return error.response.data;
        });

    }

    public updateUser(params: any) {
        const endpoint = `${this.nameSpace}/users`;
        const headers = http.getTokenHeaders();
        return http.patch(endpoint, headers, params).then((responce) => {
            return responce.data;
        }).catch((error: any) => {
            return error.response.data;
        });

    }
}

export const adminUtilsAPI = AdminUtilsAPI.instance;
